var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [
        _vm._v(
          " Olá! No Monitoramento do Coeficiente de Desempenho do Servidor (CDS) você encontra três abas: "
        ),
      ]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(" 1. "),
            _c("b", [_vm._v("CDS dos servidores")]),
            _c("br"),
            _vm._v(" 2. "),
            _c("b", [_vm._v("Relatórios Gerenciais")]),
            _c("br"),
            _vm._v(" 3. "),
            _c("b", [_vm._v("Relatórios Gerenciais por unidades")]),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v(" 1. CDS dos servidores ")]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(" Na aba "),
            _c("b", [_vm._v("“CDS dos servidores”")]),
            _vm._v(" você encontra três tipos de filtros: "),
            _c("br"),
            _vm._v(" 1. "),
            _c("b", [_vm._v("Unidade")]),
            _c("br"),
            _vm._v(" 2. "),
            _c("b", [_vm._v("Categoria")]),
            _c("br"),
            _vm._v(" 3. "),
            _c("b", [_vm._v("Servidor")]),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(" No filtro "),
            _c("b", [_vm._v("“Unidade”")]),
            _vm._v(" você pode selecionar mais de uma unidade. No filtro "),
            _c("b", [_vm._v("“Categoria”")]),
            _vm._v(
              " você faz a seleção entre: gestor, servidor ou todas. No filtro "
            ),
            _c("b", [_vm._v("“Servidor”")]),
            _vm._v(
              " você encontra os servidores da unidade de acordo com a categoria selecionada. Ao selecionar um servidor você pode analisar, por meio de gráficos e tabelas, os dados referentes ao desempenho técnico e comportamental em conjunto, no ano em análise. "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [
        _vm._v(" 1. CDS dos servidores"),
        _c("br"),
        _vm._v(" Gráficos e tabelas "),
      ]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " O primeiro gráfico apresenta a matriz de desempenho comportamentos x responsabilidade. Na área da matriz, o servidor selecionado encontra-se posicionado de acordo com as notas obtidas no desempenho comportamental e técnico. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " O velocímetro expressa o resultado médio dos CDS dos servidores. O CDS é calculado com a seguinte fórmula: "
            ),
          ]
        ),
        _c(
          "p",
          {
            staticClass: "mx-2 pa-2 text-center font-weight-medium text-lg-h6",
          },
          [_vm._v(" (nota comportamental x nota responsabilidades)/10 ")]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Na tabela “Resultado” é possível observar a descrição das notas obtidas pelo servidor e o seu CDS. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Para melhor interagir com a tabela, pode-se utilizar os recursos de ordenação de forma crescente ou decrescente por: servidor, resultado comportamental, resultado técnico e CDS. Filtrar por situação: atende, em desenvolvimento e não atende. E, por fim, é possível pesquisar por qualquer termo exibido na tabela. "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v(" 2. Relatórios gerenciais ")]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(" Na aba "),
            _c("b", [_vm._v("“Relatórios gerenciais”")]),
            _vm._v(
              " você encontra o filtro “Unidade”. Ao selecionar uma ou mais unidades, é possível analisar, por meio de gráficos e tabelas, dados conjuntos da(s) unidade(s). "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-center font-weight-bold text-lg-h6" },
          [_vm._v(" Gráficos e tabelas ")]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " O gráfico de pizza apresenta a distribuição dos CDS dos servidores da unidade nas categorias: atende, em desenvolvimento e não atende. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " A tabela traz a relação das unidades selecionadas e a quantidade de CDS nas respectivas categorias. É possível observar a média e o desvio padrão dos CDS por unidade. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Ao final, apresenta-se, quando houver, a relação das unidades que tiveram todos os servidores com CDS inviabilizado. "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v(" 3. Relatórios gerenciais por unidade ")]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(" Na aba "),
            _c("b", [_vm._v("“Relatórios gerenciais por unidade”")]),
            _vm._v(
              " você encontra o filtro “Unidade”. Ao selecionar uma unidade, é possível analisar, por meio de gráficos e tabelas, dados conjuntos da unidade. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-center font-weight-bold text-lg-h6" },
          [_vm._v(" Gráficos e tabelas ")]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " O gráfico de pizza apresenta a distribuição dos servidores da unidade nas categorias: atende, em desenvolvimento e não atende. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " A tabela traz a relação de servidores, o resultado do CDS de cada um e a categoria do seu CDS. É possível observar a média e o desvio padrão dos CDS dos servidores da unidade. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Ao final, apresenta-se a relação de servidores que tiveram o CDS inviabilizado por falta de resultado comportamental ou técnico. "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("div", { staticClass: "mx-2 pa-2 justify-center" }, [
        _c("ul", [
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(" Recomenda-se visitar a aba "),
                _c("b", [_vm._v("1. “CDS dos Servidores”")]),
                _vm._v(" para analisar o CDS de cada servidor. "),
              ]
            ),
          ]),
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(" Recomenda-se visitar a aba "),
                _c("b", [_vm._v("2. “Relatórios gerenciais”")]),
                _vm._v(
                  " para analisar o resultado conjunto dos CDS das unidades e verificar se houve casos de unidades onde todos os servidores tiveram os CDS inviabilizados. "
                ),
              ]
            ),
          ]),
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(" Recomenda-se visitar a aba "),
                _c("b", [_vm._v("3. “Relatórios gerenciais por unidade”")]),
                _vm._v(
                  " para analisar o resultado conjunto dos CDS dos servidores da unidade e verificar se houve casos de CDS inviabilizados. "
                ),
              ]
            ),
          ]),
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(
                  " O Gestor pode trabalhar os dados expostos, por meio dos gráficos e tabelas, com sua equipe no intuito de verificar as categorias: atende, em desenvolvimento, não atende e direcionar ações para o reconhecimento do servidor ou para seu desenvolvimento. Todos os resultados podem auxiliar o processo de sucessão do gestor da unidade. "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }